<app-labeled-section [header]="'LABEL.PAYMENT_OPTIONS' | translate">
  <app-form-master *ngIf="form" [form]="form">
    <app-payment-options
      class="payment-options"
      [showI2gMoney]="showI2gMoney"
      [showBankTransfer]="showBankTransfer"
      [showCardPayments]="showCardPayments"
      [showPaypalEc]="showPaypalEc"
      [paypalEcStatus]="paypalEcStatus"
      [i2gMoneyEnabled]="i2gMoneyEnabled"
      [i2gMoneyContext]="i2gMoneyContext$ | async"
      [bankTransferEnabled]="bankTransferEnabled"
      [cardPaymentsEnabled]="cardPaymentsEnabled"
      [paypalEcEnabled]="paypalEcEnabled"
      [achDebit]="paymentsSettings?.achDebit"
      [cardFeesDescription]="paymentsSettings?.cardFeesDescription"
      [underwritingUrl]="underwritingUrl"
      [availableCardTypes]="paymentsSettings?.availableCardTypes"
      [trackingObject]="documentTrackingObject"
      [trackingScreenName]="trackingScreenName"
      [paymentOptionsTrackingProperties]="paymentOptionsTrackingProperties"
      [companyCountry]="companyCountry"
      [documentType]="documentType"
      (updateI2gMoney)="onUpdateI2gMoney($event)"
      (updateBankTransfer)="onUpdateBankTransfer($event)"
      (updateCardPayments)="onUpdateCardPayments($event)"
      (updatePaypal)="onUpdatePaypal($event)"
      (confirmSetupBankTransferDialog)="onConfirmSetupBankTransferDialog()"
    >
    </app-payment-options>

    <div *ngIf="showPaymentReminders" class="reminders">
      <app-checkbox-field
        class="reminders-checkbox"
        fieldId="reminders_enabled_field"
        [icon]="featureHighlightIcon"
        [label]="'LABEL.SEND_PAYMENT_REMINDERS' | translate"
        [fieldControl]="form.get(formKeys.REMINDERS_ENABLED)"
        [trackingObject]="documentTrackingObject"
        trackingIdentifier="payment_reminders"
        [trackingScreenName]="trackingScreenName"
        [trackingAdditionalProperties]="paymentOptionsTrackingProperties"
        (onClickIcon)="showFeatureHighlightDialog()"
      >
      </app-checkbox-field>

      <button
        type="button"
        class="view-reminders-button"
        trackable
        [trackingObject]="documentTrackingObject"
        [trackingAction]="viewRemindersTrackingAction"
        (click)="openViewRemindersDialog()"
      >
        {{ 'ACTION.VIEW' | translate }}
      </button>

      <app-reminders-disabled-dialog></app-reminders-disabled-dialog>

      <app-view-reminders-dialog
        (onSendRemindersPreview)="sendRemindersPreview()"
      ></app-view-reminders-dialog>
    </div>
  </app-form-master>
</app-labeled-section>

<app-confirm-dialog
  [dialogId]="invalidEmailDialogId"
  [confirmTitle]="'LABEL.CLIENT_EMAIL_REQUIRED' | translate"
  [confirmPrompt]="'DIALOG.REMINDERS.INVALID_EMAIL_INFO' | translate"
  [cancelText]="'ACTION.CANCEL' | translate"
  [yesText]="'ACTION.ADD_CLIENT_EMAIL' | translate"
  [isDeleteAction]="true"
  (onClose)="onInvalidClientEmail($event)"
>
</app-confirm-dialog>
